/*
  Flocage et badge payants après l'offre « flocage offert ».

  Réglage : Paramètres du thème → Offre flocage. Tant que l'offre est active et que sa date de fin
  (heure de Paris) n'est pas passée, rien ne change : le flocage reste gratuit. Ensuite :
  - un maillot floqué (Nom ou Numéro) emporte une ligne « Flocage nom & numéro » ;
  - chaque badge (Badge, Badge 2) emporte une ligne « Badge de manche ».
  Les lignes sont reliées au maillot par la propriété cachée _lien et suivent sa quantité.

  reconcilier() remet le panier en ordre après chaque modification du panier, repérée sur les
  appels fetch du thème (et au chargement) : donne un _lien aux maillots personnalisés, ajoute ce
  qui manque, ajuste les quantités, retire les lignes orphelines. « Commander » attend la fin d'une
  remise en ordre en cours. Réglages venus de sections/announcement-bar.liquid (window.mfPerso).

  Affichage : prix du flocage et du badge sur la fiche, note « photo avant l'envoi », lignes de
  personnalisation simplifiées au panier, prix à côté de « Ajouter un flocage ».

  Test sans attendre la date : ?mf_perso=payant (ou ?mf_perso=offert), mémorisé pour l'onglet.
*/
(function () {
  var C = window.mfPerso;
  if (!C || C.pret) return;
  C.pret = true;

  var TEXTES = {
    fr: {
      ensuite: '%s ensuite',
      photo: 'Avant l’envoi, tu reçois une photo de ton maillot floqué : tu vois exactement ce qui part.'
    },
    en: {
      ensuite: 'then %s',
      photo: 'Before shipping, you get a photo of your printed shirt, so you see exactly what is on its way.'
    },
    es: {
      ensuite: 'después %s',
      photo: 'Antes del envío, recibes una foto de tu camiseta estampada: ves exactamente lo que sale.'
    }
  };
  var T = TEXTES[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || TEXTES.fr;

  function jourParis() {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date());
  }

  function forcage() {
    try {
      var q = new URLSearchParams(window.location.search).get('mf_perso');
      if (q === 'payant' || q === 'offert') sessionStorage.setItem('mf_perso', q);
      return sessionStorage.getItem('mf_perso');
    } catch (e) {
      return null;
    }
  }

  C.payant = function () {
    if (!C.flocage && !C.badge) return false;
    var f = forcage();
    if (f === 'payant') return true;
    if (f === 'offert') return false;
    if (!C.offreActive) return true;
    if (!C.offreFin) return false; // offre sans date de fin : le flocage reste offert
    return jourParis() > C.offreFin;
  };

  function nouveauLien() {
    return 'L' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function besoins(props, quantite) {
    props = props || {};
    var badges = (props['Badge'] ? 1 : 0) + (props['Badge 2'] ? 1 : 0);
    return {
      f: props['Nom'] || props['Numéro'] ? quantite : 0,
      b: badges * quantite
    };
  }

  /* ---------- remise en ordre du panier ---------- */
  var routes = window.routes || {};
  function url(nom, defaut) { return (routes[nom] || defaut) + '.js'; }

  // En-tête qui distingue nos appels de ceux du thème (voir surveillerPanier).
  var NOTRE_APPEL = 'X-MF-Perso';

  function appel(adresse, corps) {
    var entetes = { 'Content-Type': 'application/json', Accept: 'application/json' };
    entetes[NOTRE_APPEL] = '1';
    return fetch(adresse, {
      method: corps ? 'POST' : 'GET',
      headers: entetes,
      body: corps ? JSON.stringify(corps) : undefined
    }).then(function (r) { return r.json(); });
  }

  function estPerso(ligne) {
    return ligne.variant_id === C.flocage || ligne.variant_id === C.badge;
  }

  function libelle(ligne) {
    return ligne.product_title + (ligne.variant_title ? ' – ' + ligne.variant_title : '');
  }

  var occupe = false;
  var encore = false;

  function tour(n, etat) {
    if (n > 8) return Promise.resolve();
    return appel(url('cart_url', '/cart')).then(function (panier) {
      var lignes = panier.items || [];

      // 1. Un maillot personnalisé sans _lien en reçoit un (une ligne à la fois).
      for (var i = 0; i < lignes.length; i++) {
        var l = lignes[i];
        if (estPerso(l)) continue;
        var bl = besoins(l.properties, l.quantity);
        if ((bl.f || bl.b) && !(l.properties && l.properties._lien)) {
          var props = Object.assign({}, l.properties, { _lien: nouveauLien() });
          etat.change = true;
          return appel(url('cart_change_url', '/cart/change'), { id: l.key, quantity: l.quantity, properties: props })
            .then(function () { return tour(n + 1, etat); });
        }
      }

      // 2. Ce que chaque maillot demande.
      var voulu = {};
      lignes.forEach(function (l) {
        if (estPerso(l) || !l.properties || !l.properties._lien) return;
        var b = besoins(l.properties, l.quantity);
        var v = voulu[l.properties._lien] || (voulu[l.properties._lien] = { f: 0, b: 0, pour: libelle(l) });
        v.f += b.f;
        v.b += b.b;
      });

      // 3. Ajuster les lignes existantes, retirer les doublons et les orphelines.
      var quantites = {};
      var vues = {};
      lignes.forEach(function (l) {
        if (!estPerso(l)) return;
        var lien = l.properties && l.properties._lien;
        var type = l.variant_id === C.flocage ? 'f' : 'b';
        var cle = lien + '|' + type;
        var cible = lien && voulu[lien] && !vues[cle] ? voulu[lien][type] : 0;
        vues[cle] = true;
        if (l.quantity !== cible) quantites[l.key] = cible;
      });

      // 4. Ajouter ce qui manque.
      var ajouts = [];
      Object.keys(voulu).forEach(function (lien) {
        var v = voulu[lien];
        if (v.f && C.flocage && !vues[lien + '|f']) ajouts.push({ id: C.flocage, quantity: v.f, properties: { _lien: lien, Pour: v.pour } });
        if (v.b && C.badge && !vues[lien + '|b']) ajouts.push({ id: C.badge, quantity: v.b, properties: { _lien: lien, Pour: v.pour } });
      });

      var suite = Promise.resolve();
      if (Object.keys(quantites).length) {
        etat.change = true;
        suite = suite.then(function () { return appel(url('cart_update_url', '/cart/update'), { updates: quantites }); });
      }
      if (ajouts.length) {
        etat.change = true;
        suite = suite.then(function () { return appel(url('cart_add_url', '/cart/add'), { items: ajouts }); });
      }
      return suite;
    });
  }

  // Une seule remise en ordre à la fois (occupe = sa promesse). Un appel pendant qu'elle tourne
  // demande un passage de plus et reçoit la même promesse, résolue quand le panier est stable.
  function passe() {
    encore = false;
    var etat = { change: false };
    return tour(0, etat)
      .catch(function (e) { console.error('mf-flocage-payant', e); })
      .then(function () {
        // PUB_SUB_EVENTS est déclaré en « const » par le thème : il n'existe pas sur window.
        if (etat.change && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mf-perso' });
        }
        return encore ? passe() : etat.change;
      });
  }

  function reconcilier() {
    if (!C.payant()) return Promise.resolve(false);
    if (occupe) {
      encore = true;
      return occupe;
    }
    occupe = passe().then(function (change) {
      occupe = false;
      return change;
    });
    return occupe;
  }
  C.reconcilier = reconcilier;

  var attente = null;
  function planifierReconciliation() {
    clearTimeout(attente);
    attente = setTimeout(function () {
      attente = null;
      reconcilier();
    }, 300);
  }

  /*
    Toute modification du panier par le thème (fiche, tiroir, page panier, flocage modifié dans le
    tiroir, ajouts rapides) passe par fetch vers /cart/add, /cart/change, /cart/update ou /cart/clear.
    On la laisse partir, puis on remet le panier en ordre. Nos propres appels portent NOTRE_APPEL.
  */
  function surveillerPanier() {
    var fetchOrigine = window.fetch;
    if (!fetchOrigine || fetchOrigine.mfPerso) return;
    var enveloppe = function (entree, options) {
      var promesse = fetchOrigine.apply(this, arguments);
      try {
        var adresse = typeof entree === 'string' ? entree : (entree && (entree.url || entree.href)) || '';
        var entetes = (options && options.headers) || {};
        var nous = typeof entetes.get === 'function' ? entetes.get(NOTRE_APPEL) : entetes[NOTRE_APPEL];
        if (!nous && /\/cart\/(add|change|update|clear)\b/.test(adresse)) {
          promesse.then(function (r) { if (r.ok) planifierReconciliation(); }, function () {});
        }
      } catch (e) { /* surveillance seulement : ne jamais bloquer l'appel du thème */ }
      return promesse;
    };
    enveloppe.mfPerso = true;
    window.fetch = enveloppe;
  }

  // « Commander » cliqué pendant une remise en ordre : on attend qu'elle finisse, puis on repart.
  function retenirPaiement() {
    document.addEventListener('click', function (e) {
      var bouton = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!bouton || !C.payant() || (!attente && !occupe)) return;
      var formulaire = bouton.form;
      if (!formulaire || typeof formulaire.requestSubmit !== 'function') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      clearTimeout(attente);
      attente = null;
      reconcilier().then(function () { formulaire.requestSubmit(bouton); });
    }, true);
  }

  /* ---------- affichage ---------- */
  function span(texte, classe) {
    var s = document.createElement('span');
    s.className = classe;
    s.textContent = texte;
    return s;
  }

  function decorerFiche() {
    var blocs = document.querySelectorAll('.mflo');
    for (var i = 0; i < blocs.length; i++) {
      var mflo = blocs[i];
      if (mflo.dataset.mfDecor === '1') continue;
      mflo.dataset.mfDecor = '1';

      var titre = mflo.querySelector('.mflo__titre');
      if (titre && C.prixFlocage) {
        if (C.payant()) titre.appendChild(span(' · ' + C.prixFlocage, 'mflo__optionnel'));
        else if (C.offreFin) titre.appendChild(span(' · ' + T.ensuite.replace('%s', C.prixFlocage), 'mflo__optionnel'));
      }

      var titreBadge = mflo.querySelector('.mflo__badges-zone .mflo__ss-titre');
      if (titreBadge && C.prixBadge && C.payant()) titreBadge.appendChild(span(' · ' + C.prixBadge, 'mflo__optionnel'));

      var legal = mflo.querySelector('[data-legal]');
      if (legal) {
        var photo = document.createElement('p');
        photo.className = 'mflo__legal mflo__photo';
        photo.textContent = T.photo;
        photo.hidden = legal.hidden;
        legal.parentNode.insertBefore(photo, legal);
        new MutationObserver(function () { photo.hidden = legal.hidden; })
          .observe(legal, { attributes: true, attributeFilter: ['hidden'] });
      }
    }
  }

  function estLigneDePerso(ligne) {
    var lien = ligne.querySelector('a.cart-item__name, a.cart-item__link');
    var href = lien ? lien.getAttribute('href') || '' : '';
    return href.indexOf('/products/flocage-nom-numero') !== -1 || href.indexOf('/products/badge-de-manche') !== -1;
  }

  function decorerPanier() {
    var lignes = document.querySelectorAll('.cart-item');
    for (var i = 0; i < lignes.length; i++) {
      var ligne = lignes[i];
      if (estLigneDePerso(ligne)) {
        ligne.classList.add('mf-perso');
        var cellule = ligne.querySelector('.cart-item__quantity');
        var champ = ligne.querySelector('input.quantity__input');
        if (cellule && champ && !cellule.querySelector('.mf-perso-qte')) {
          var q = document.createElement('p');
          q.className = 'mf-perso-qte';
          q.textContent = '× ' + champ.value;
          cellule.insertBefore(q, cellule.firstChild);
        }
      } else if (C.payant() && C.prixFlocage) {
        var ajouts = ligne.querySelectorAll('.mf-panier__flocage');
        for (var j = 0; j < ajouts.length; j++) {
          var p = ajouts[j];
          if (p.querySelector('b') || p.querySelector('.mf-perso-prix')) continue; // déjà floqué, ou déjà fait
          if (!p.querySelector('[data-mfp-flocage]')) continue;
          p.appendChild(span(' · ' + C.prixFlocage, 'mf-panier__options mf-perso-prix'));
        }
      }
    }
  }

  var minuteur = null;
  function decorer() {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      decorerFiche();
      decorerPanier();
    }, 50);
  }

  function demarrer() {
    decorer();
    new MutationObserver(decorer).observe(document.body, { childList: true, subtree: true });
    retenirPaiement();
    reconcilier();
  }

  // Les champs Nom / Numéro du flocage dans le tiroir sont dans cart-drawer-items, qui prend tout
  // « change » pour une quantité (validateQuantity de cart.js) : message d'erreur absurde et
  // exception. Ces champs n'ont pas besoin de « change » ; on l'arrête avant qu'il n'y arrive.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-mfp-flocage-form]')) e.stopPropagation();
  }, true);

  surveillerPanier();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
